import { getBackendUrl } from '../config/urls';

/** URL publique d'un fichier dans uploads/demenageurs/ (API backend, pas le port admin). */
export function demenageurUploadUrl(filename) {
  if (!filename || typeof filename !== 'string') return null;
  const base = getBackendUrl().replace(/\/$/, '');
  if (!base) return null;
  return `${base}/uploads/demenageurs/${encodeURIComponent(filename.trim())}`;
}

/** Ajoute frontUrl / backUrl si des noms de fichiers recto/verso sont présents. */
export function enrichDocumentWithUrls(doc) {
  if (!doc || typeof doc !== 'object') return doc;
  const front = doc.front || doc.recto;
  const back = doc.back || doc.verso;
  return {
    ...doc,
    ...(front ? { frontUrl: doc.frontUrl || demenageurUploadUrl(front) } : {}),
    ...(back ? { backUrl: doc.backUrl || demenageurUploadUrl(back) } : {}),
  };
}
